import React, { FC } from 'react';
import classNames from 'classnames';
import getClassNames from 'src/common/utils/getClassNames';
import Icon, { IconIds } from 'src/common/components/IconDS22';
import Typography from 'src/common/components/Typography';
import UniversalLink from 'src/common/components/UniversalLink';
import styles from './PitchPageResource.module.scss';

export type IconColor = 'bluminescence-01' | 'sunset' | 'sand' | 'midnight-01';

export type PitchPageResourceProps = {
  iconId: IconIds;
  iconColor: IconColor;
  title: string;
  text: string;
  linkText: string;
  linkHref: string;
  withLinkArrow?: boolean;
  withNewTabAttributes?: boolean;
  colorVariant?: 'neutral-700' | 'midnight-01';
  textSize?: 'body-l' | 'body-xl';
};

const PitchPageResource: FC<PitchPageResourceProps> = ({
  iconId,
  iconColor,
  title,
  text,
  linkText,
  linkHref,
  withLinkArrow = true,
  withNewTabAttributes = true,
  colorVariant = 'neutral-700',
  textSize = 'body-l',
}) => (
  <li className={getClassNames(styles, 'root', classNames(colorVariant))}>
    <Icon id={iconId} size="xl" className={getClassNames(styles, 'listItemIcon', classNames(iconColor))} />
    <div className={styles.listItemTitle}>
      <Typography
        type="h3"
        size="heading-5"
        weight="semibold"
      >
        {title}
      </Typography>
    </div>
    <div className={styles.listItemText}>
      <Typography type="p" size={textSize}>{text}</Typography>
    </div>
    <UniversalLink
      href={linkHref}
      className={getClassNames(styles, 'listItemLink', classNames({ withLinkArrow }))}
      openInNewTab={withNewTabAttributes}
    >
      <Typography
        type="p"
        size="body-l"
        weight={withLinkArrow ? 'semibold' : 'regular'}
      >
        {linkText}
      </Typography>
      {withLinkArrow && <Icon id="arrow-right" className={styles.arrow} />}
    </UniversalLink>
  </li>

);

export default PitchPageResource;
